module.exports = __webpack_public_path__ + "static/media/status-frozen.52a3f028.svg";